var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React, { Component } from 'react';
import PricingGridChart from './PricingGridChart';
import { connect } from 'react-redux';
import { shapes } from '@cimpress/react-components';
import PriceAnalysis from './PriceAnalysis';
import '../../styles/pricingChart.css';
import '../../styles/charts.css';
import { getPriceRangeForCatalog, getPriceRangeForContract } from './chartUtils';

var PricingChart =
/** @class */
function (_super) {
  __extends(PricingChart, _super);

  function PricingChart(props) {
    var _this = _super.call(this, props) || this;

    _this.componentDidCatch = function (error, info) {
      if (_this.props.logger) {
        _this.props.logger.logError({
          message: 'Error occurred in PricingChart Error Boundary',
          error: {
            errorInfo: error,
            info: info
          }
        }, 'pricingGrid');
      }
    };

    _this.getInitialState = function () {
      return {
        selectedContract: null,
        pricingGridChartType: 'line',
        showPriceAnalysis: false,
        priceAnalysisChartType: 'area',
        toggleOn: true,
        showSpinner: true,
        priceRangeResults: null,
        displayPriceAnalysisButton: false
      };
    };

    _this.togglePriceAnalysis = function () {
      var showPriceAnalysis = _this.state.showPriceAnalysis;

      _this.setState({
        showPriceAnalysis: !showPriceAnalysis
      });
    };

    _this.changePricingGridChartType = function (chartType) {
      _this.setState({
        pricingGridChartType: chartType
      });
    };

    _this.changeSelectedContract = function (contract) {
      _this.setState({
        selectedContract: contract
      });
    };

    _this.getPriceRange = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var skuData, _a, contractsPerSku, sellersPerSku, currency, sku, contracts, sellers, sellerInfo, catalogPromise, contractPromise, results, _b, catalogPriceRange, contractPriceRange, priceRangeResults;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              skuData = this.props.pricingGrid.skuData;
              _a = this.props, contractsPerSku = _a.contracts, sellersPerSku = _a.sellers, currency = _a.currency;
              sku = Object.keys(skuData)[0];
              contracts = contractsPerSku[sku];
              sellers = sellersPerSku[sku];
              sellerInfo = Object.values(sellers);
              catalogPromise = [];
              contractPromise = [];

              if (sellerInfo) {
                catalogPromise = sellerInfo.map(function (seller) {
                  return getPriceRangeForCatalog(seller, sku, currency);
                });
              }

              if (contracts) {
                contractPromise = contracts.map(function (contract) {
                  return getPriceRangeForContract(contract, sku, currency);
                });
              }

              return [4
              /*yield*/
              , Promise.all([Promise.all(catalogPromise), Promise.all(contractPromise)])];

            case 1:
              results = _c.sent();
              _b = __read(results, 2), catalogPriceRange = _b[0], contractPriceRange = _b[1];
              priceRangeResults = {}; // Using ...[index][0] of result as we get nested array in response

              if (sellerInfo) {
                sellerInfo.forEach(function (seller, index) {
                  var _a;

                  var key = seller.sellerName;

                  if (catalogPriceRange[index][0] && !catalogPriceRange[index][0].error) {
                    _a = __read(catalogPriceRange[index], 1), priceRangeResults[key.toLowerCase()] = _a[0];
                  }
                });
              }

              if (contracts) {
                contracts.forEach(function (contract, index) {
                  var _a;

                  var key = sellers[contract.seller.sellerId].sellerName + "-" + contract.buyer.buyerId;

                  if (contractPriceRange[index][0] && !contractPriceRange[index][0].error) {
                    _a = __read(contractPriceRange[index], 1), priceRangeResults[key.toLowerCase()] = _a[0];
                  }
                });
              }

              return [2
              /*return*/
              , priceRangeResults];
          }
        });
      });
    };

    _this.state = _this.getInitialState();
    return _this;
  }

  PricingChart.prototype.componentDidMount = function () {
    var _this = this;

    if (this.props.pricingVersion === 'v1') {
      this.getPriceRange().then(function (priceRangeResults) {
        var displayPriceAnalysisButton = true;

        if (!priceRangeResults || Object.keys(priceRangeResults).length === 0) {
          displayPriceAnalysisButton = false;
        }

        _this.setState({
          priceRangeResults: priceRangeResults,
          showSpinner: false,
          displayPriceAnalysisButton: displayPriceAnalysisButton
        });
      });
    } else {
      this.setState({
        showSpinner: false,
        displayPriceAnalysisButton: false
      });
    }
  };

  PricingChart.prototype.render = function () {
    var _a = this.props.pricingGrid,
        skuData = _a.skuData,
        parentService = _a.parentService;
    var _b = this.state,
        showPriceAnalysis = _b.showPriceAnalysis,
        pricingGridChartType = _b.pricingGridChartType,
        selectedContract = _b.selectedContract,
        showSpinner = _b.showSpinner,
        displayPriceAnalysisButton = _b.displayPriceAnalysisButton,
        priceRangeResults = _b.priceRangeResults;
    var currency = this.props.currency;
    var _c = Object.values(skuData)[0],
        selectedRow = _c.selectedRow,
        selectedColumn = _c.selectedColumn;
    var pivotKeyRow;

    if (selectedRow) {
      pivotKeyRow = selectedRow.key;
    }

    var pivotKeyColumn;

    if (selectedColumn) {
      pivotKeyColumn = selectedColumn.key;
    }

    var _d = this.props,
        gridData = _d.gridData,
        headers = _d.headers,
        priceMode = _d.priceMode;
    var Spinner = shapes.Spinner;

    if (!gridData || gridData.length === 0 || showSpinner) {
      return React.createElement(Spinner, {
        className: "flex-center spinner-div"
      });
    }

    return React.createElement("div", null, !showPriceAnalysis ? React.createElement("div", null, React.createElement(PricingGridChart, {
      gridData: gridData,
      headers: headers,
      pivotKeyRow: pivotKeyRow,
      pivotKeyColumn: pivotKeyColumn,
      priceMode: priceMode,
      pricingGridChartType: pricingGridChartType,
      changePricingGridChartType: this.changePricingGridChartType,
      selectedContract: selectedContract,
      changeSelectedContract: this.changeSelectedContract,
      togglePriceAnalysis: this.togglePriceAnalysis,
      displayPriceAnalysisButton: displayPriceAnalysisButton,
      parentService: parentService
    })) : React.createElement("div", null, React.createElement(PriceAnalysis, {
      gridData: gridData,
      headers: headers,
      pivotKeyRow: pivotKeyRow,
      pivotKeyColumn: pivotKeyColumn,
      priceMode: priceMode,
      currency: currency,
      priceRangeResults: priceRangeResults,
      togglePriceAnalysis: this.togglePriceAnalysis
    })));
  };

  return PricingChart;
}(Component);

function mapStateToProps(state) {
  return {
    pricingGrid: state.pricingGrid
  };
}

var mapDispatchToProps = {};
var connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(PricingChart);